var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-card",
    [
      _c(
        "emd-card-header",
        { staticClass: "eu-justify_between" },
        [
          _c(
            "div",
            {
              staticClass: "eu-flex eu-justify_center eu-align_center eu-px_2",
            },
            [
              _c("emd-text", { attrs: { size: "section" } }, [
                _vm._v(" " + _vm._s(_vm.$t("header")) + ": "),
              ]),
              _c("emd-text", { attrs: { size: "text" } }, [
                _vm._v("   " + _vm._s(_vm.data.id) + " "),
              ]),
            ],
            1
          ),
          _vm._t("actions"),
        ],
        2
      ),
      _c(
        "emd-card-content",
        { attrs: { customClass: "eu-no-padding" } },
        [
          _c("table-links", {
            attrs: { fields: _vm.fields, items: [_vm.data] },
          }),
        ],
        1
      ),
      _vm._t("modal"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }